import { useEffect, useState } from "react"
import useHospitalData from "hooks/useHospitalData"

const defaultDepartmentOptions = {
  text: "------",
  value: "",
}

export const useDepartmentsForForm = (setDepartment, setServerState, hospitalId, departmentId, answeredCall) => {
  const [departmentInitialized, setDepartmentInitialized] = useState(false)
  const [departmentOptions, setDepartmentOptions] = useState([])
  const { getDepartments } = useHospitalData(hospitalId)
  const hasAnsweredCall = Boolean(answeredCall)

  useEffect(() => {
    if (!hasAnsweredCall) return

    const departments = getDepartments()
    if (!departments) return

    const mappedOptions = [defaultDepartmentOptions, ...departments].map((dep) => ({
      text: dep.text ?? dep.name,
      value: dep.value ?? dep.id,
    }))
    setDepartmentOptions(
      mappedOptions
    )
  }, [getDepartments, hasAnsweredCall, setDepartment, setServerState])

  useEffect(() => {
    if (!hospitalId) {
      setDepartmentOptions([defaultDepartmentOptions])
    }
  }, [hospitalId, setDepartment])

  useEffect(() => {
    if (departmentId && departmentOptions.length && !departmentInitialized) {
      setDepartment((v) => v || departmentId)
      setServerState((state) => ({
        ...state,
        departmentId: state.departmentId || departmentId,
      }))
      setDepartmentInitialized(true)
    }
  }, [departmentId, departmentOptions, setDepartment, setServerState, departmentInitialized])

  useEffect(() => {
    if (!hasAnsweredCall) {
      setDepartmentOptions([defaultDepartmentOptions])
      setDepartment("")
      setDepartmentInitialized(false)
    }
  }, [hasAnsweredCall, setDepartment])

  return {
    departmentOptions,
  }
}
